/* eslint-disable import/prefer-default-export */
/** LaunchDarkly flag key for the Invoice Service V2 migration. */
export const INVOICES_V2 = 'releaseBeInvoicesV2';
